import { Schedule as ScheduleIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";

import { AddEventTimesDialog } from "./AddEventTimesDialog";
import { type AddEventTimesModalProps } from "./AddEventTimesModal.types";

export const AddEventTimesModal = ({
  onSubmit,
  disabled = false,
  eventId,
  defaultDate,
  series,
}: AddEventTimesModalProps) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<ScheduleIcon />}
        onClick={() => setOpen(true)}
        disabled={disabled}
        aria-label="Add event times"
        data-testid="add-meeting-times-button"
        sx={{
          minWidth: "auto",
          textTransform: "none",
        }}
      >
        Create
      </Button>

      <AddEventTimesDialog
        open={open}
        onClose={() => setOpen(false)}
        onSubmit={onSubmit}
        eventId={eventId}
        defaultDate={defaultDate}
        series={series}
      />
    </>
  );
};
